import RegForms from './RegForms';

export default RegForms;
